module.exports = "<div class=\"page card\">\n  <section class=\"card text-center\">\n      <div class=\"card-block\">\n          <div class=\"error-code\">404</div>\n          <h3 class=\"font-bold\">ページが見つかりません</h3>\n      </div>\n  </section>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/error/not-found/not-found.component.html
// module id = ../../../../../src/app/error/not-found/not-found.component.html
// module chunks = main